// Port of src/app/animations/pixelateInOutDelay.ts (Angular trigger 'pixelateInOutDelay').
//
// Angular spec: :enter from { opacity: 0, blur(5px) } -> { opacity: 1, blur(0) }
// over 300ms with a 1s delay, ease-in; :leave -> { opacity: 0, blur(5px) }
// over 1ms ease-out (effectively instant).
//
// Ported as CSS keyframe classes (see react/src/styles/animations.scss).
// ENTER_TOTAL_MS includes the 1s delay. For leave, apply the leave class and
// unmount after PIXELATE_IN_OUT_DELAY_LEAVE_MS.

export const PIXELATE_IN_OUT_DELAY_ENTER_CLASS = 'pixelate-in-out-delay-enter';
export const PIXELATE_IN_OUT_DELAY_LEAVE_CLASS = 'pixelate-in-out-delay-leave';

export const PIXELATE_IN_OUT_DELAY_ENTER_TOTAL_MS = 1300; // 1000ms delay + 300ms animation
export const PIXELATE_IN_OUT_DELAY_LEAVE_MS = 1;
